import styled from 'styled-components';
import { zIndex } from 'config/styles';

export const Header = styled.div`
  width: 100%;
  padding: 30px 30px 0 30px;
`;

export const Body = styled.div`
  position: relative;
  padding: 30px;
`;

export const Footer = styled.div`
  position: 100%;
  padding: 10px 30px 30px 30px;
`;

export const Overlay = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  position: fixed;
  background: #000000b8;
  top: 0%;
  right: 0;
  bottom: 0;
  z-index: ${zIndex.lv3};
  left: ${(props) => (props.show ? '0' : '-200%')};
  overflow-y: scroll;
`;

export const Container = styled.div`
  width: 100vw;
  max-width: 450px;
  height: auto;
  border-radius: 15px;
  position: fixed;
  top: ${(props) => (props.show ? '0' : '-200%')};
  left: 0;
  margin-top: 50px;
  transition: top ease-in-out 0.4s;
  background: ${({ theme }) => theme.colors.secondary.w350};
  box-shadow: 0px 0px 30px 2px rgba(0, 0, 0, 0.4);
  z-index: ${zIndex.lvMax};

  
  & ~ div, ul {
    filter: ${({ show }) => show && 'blur(10px)'};
    overflow: ${({ show }) => show && 'hidden'};
  }

  @media (min-width: 450px) {
    left: calc(50% - 225px);
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  > h1 {
    margin-left: 0.4em;
    color: ${({ theme }) => theme.colors.text.w000};
  }
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.text.w000};
  font-size: 18px;
  text-align: center;
`;
